import { useMemo, useEffect } from 'react'

import { useStudent } from 'app/dataProviders/student/hooks'
import { Loading, PageTemplateContent } from 'app/common/templates-next/page-template'
import Sticky from 'app/common/templates-next/sticky'
import { Limits, Pin, Subsidies } from 'app/components/Cafeteria/Settings'

import getBaseUrl from '../getBaseUrl'
import useSchoolAsCamp from '../useSchoolAsCamp'
import { SettingsPageNavigation, SettingsSubPage, isSettingsSubPage } from './SettingsPageNavigation'


type Props = {
  params: {
    id: string,
    section: string,
    schoolType: string
  },
  router: {
    push: (path: string) => void,
  }
}

const SettingsPage = ({ params: { id, section, schoolType }, router: { push } }: Props) => {
  const student = useStudent(id)
  const validSection = isSettingsSubPage(section) ? section : null

  const availableSections = useMemo(() => {
    return schoolType === 'camp' ? [
      SettingsSubPage.Subsidies,
    ] : [
      SettingsSubPage.Limits,
      SettingsSubPage.Subsidies,
      SettingsSubPage.Pin,
    ]
  }, [schoolType])

  const baseUrl = `${getBaseUrl({ id, schoolType })}/settings`
  const { id: campId } = useSchoolAsCamp(id, schoolType)

  useEffect(() => {
    if (!(validSection && availableSections.includes(validSection))) {
      push(`${baseUrl}/${availableSections[0]}`)
    }
  }, [section, availableSections]) // eslint-disable-line react-hooks/exhaustive-deps

  if (!student || !student.accountID) {
    return <Loading />
  }

  const { person, accountID, splitStudentDayLimit, schoolID } = student
  const orgID = schoolType === 'camp' ? String(campId) : schoolID

  return (
    <>
      <Sticky>
        {(ref, _, shadow) => (
          <PageTemplateContent reference={ref} shadowBottom={shadow}>
            <SettingsPageNavigation
              baseUrl={baseUrl}
              availableSections={availableSections}
              active={validSection}
            />
          </PageTemplateContent>
        )}
      </Sticky>

      {validSection === SettingsSubPage.Limits
        && orgID
        && <Limits
          orgID={orgID}
          accountID={accountID}
          splitLimitEnabled={splitStudentDayLimit}
        />}

      {validSection === SettingsSubPage.Pin
        && <Pin accountID={accountID} />}

      {validSection === SettingsSubPage.Subsidies
        && <Subsidies
          person={person}
          orgID={orgID}
          accountID={accountID}
        />}
    </>
  )
}

export default SettingsPage
